import React from 'react';
import RadialNew from '../components/RadialNew';

const SubNew = () => {
  return (
    <section id="get-onboard" className="">
      <RadialNew />
    </section>
  );
};
export default SubNew;